export class PackagesModel {
  label: string | null;
  packages: number | null;
  revenue: number | null;

  constructor(obj?: Partial<PackagesModel>) {
    this.label = obj?.label ?? null;
    this.revenue = obj?.revenue || null;
    this.packages = obj?.packages || null;
  }
}
